import React from 'react';

const Blogs = () => {
    return (
        <div>
            <h2>Blogs are comming soon</h2>
        </div>
    );
};

export default Blogs;